import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from "@ngrx/store";
import { I18nModule } from '@spartacus/core';
import { FormErrorsModule, IconModule } from '@spartacus/storefront';
import { CustomIconsModule } from "../../../../../../../custom/icons/custom-icons.module";
import { CustomRegionsEffects } from '../../../../../core/user/store/effects/regions-zone.effect';
import {
  reducerRegionsByZoneProvider,
  reducerRegionsByZoneToken
} from '../../../../../core/user/store/reducers/regions-zone.reducer';
import { CustomAddressFormComponent } from './custom-address-form.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    IconModule,
    I18nModule,
    CustomIconsModule,
    FormErrorsModule,
    StoreModule.forFeature('user-zone', reducerRegionsByZoneToken),
    EffectsModule.forFeature([CustomRegionsEffects]),
  ],
  declarations: [CustomAddressFormComponent],
  exports: [CustomAddressFormComponent],
  providers: [reducerRegionsByZoneProvider]
})
export class CustomAddressFormModule { }
